import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const Card = () => import('@/modules/card/pages/Card/index.vue');
const CardDetail = () => import('@/modules/card/pages/CardDetail/index.vue');
const SmartCardsCreation = () => import('@/modules/card/pages/SmartCardsCreation/index.vue');
const OffshoreLanding = () =>
  import('@/modules/card/pages/OffshoreLanding/index.vue');

export const cardRoutes: Array<RouteRecordRaw> = [
  {
    path: '/card',
    component: MainLayout,
    meta: {
      title: 'Card',
      subTitle: 'last-connection',
      showRegulatoryNotice: true,
      accessRol: {
        section: 'CARD',
        actions: ['VIEW'],
      },
    },
    children: [
      {
        path: '',
        name: 'card',
        component: Card,
      },
      {
        path: ':cardId',
        name: 'card-details',
        component: CardDetail,
        meta: {
          title: 'Smart Card',
          flag: 'feature_multiple_cards',
        },
      },
    ],
  },
  {
    path: '/card/create-multiple',
    component: EmptyLayout,
    meta: {
      title: 'Card',
      subTitle: 'last-connection',
      accessRol: {
        section: 'CARD',
        actions: ['VIEW'],
      },
      flag: 'feature_multiple_cards',
    },
    children: [
      {
        path: '',
        name: 'cardCreateMultiple',
        component: SmartCardsCreation,
      },
    ],
  },
  {
    path: '/card/offshore-landing',
    component: EmptyLayout,
    meta: {
      title: 'Smart Card en dólares',
      accessRol: {
        section: 'CARD',
        actions: ['VIEW'],
      },
    },
    children: [
      {
        path: '',
        name: 'cardOffshoreLanding',
        component: OffshoreLanding,
      },
    ],
  },
];
